/**
 * Agency-scoped users have `agency_id` on their profile; platform users do not.
 * Use these helpers so UI and API params stay consistent.
 *
 * `agencyDisplayName` shows the agency name when present; otherwise domain or a neutral label.
 */

export function getAgencyIdFromUser(user) {
  if (!user) return null;
  const id = user.agency_id ?? user.agency?.id;
  if (id == null || id === "") return null;
  const n = Number(id);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function isAgencyScopedUser(user) {
  return getAgencyIdFromUser(user) != null;
}

/** Fallback when agency has no name: domain or neutral label. */
export function agencyPickerLabel(agency, index = 0) {
  if (!agency) return "—";
  const d = (agency.domain || "").trim();
  if (d) return d;
  return `Option ${index + 1}`;
}

/** Display text for an agency in UI: prefer name, then domain / Option N. */
export function agencyDisplayName(agency, index = 0) {
  if (!agency) return "—";
  const n = (agency.name || "").trim();
  if (n) return n;
  return agencyPickerLabel(agency, index);
}

/** Seekho staff domain — used for scoped super_admin agency edit exception. */
export function emailHasSeekhoAppDomain(email) {
  return (email || "").toLowerCase().includes("seekhoapp.com");
}
